export enum ActionType {
  CANCEL,
  EDIT,
  DELETE,
  VIEW,
  BLOCK,
  SAVE,
  UPDATE,
  BOOK,
  FAVORITE,
  ACCEPT,
  REJECT,
  UNBLOCK,
  CANCEL_REQUEST,
  LOCK,
  RESET_PASSWORD,
}
